import { lazy } from "react";

export const NewNotificationPage = lazy(() => import("./newNotificationPage"));
